mutation SetupMfa {
  setupMfa(input: {}) {
    provisioningUri
    errors
  }
}
